module.exports = __webpack_public_path__ + "img/img6.af3a3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img6.png
// module id = 229
// module chunks = 0